import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetPartnerTableData: '[GetPartnerTableData] Action',
  SetPartnerData: '[SetPartnerData] Action',
  GetPartnerTranslateData: '[GetPartnerTranslateData] Action',
}

const initialPartnerState: IPartnerState = {
  partnerColumnList: [],
  partnerColumnValues: [],
  partnerDefinitions: [],
  partnerColumnNames: [],
  partnerDataTypes: [],
  partnerDe: [],
  partnerEn: [],

  partnersOptions: []
}

export interface IPartnerState {
  partnerColumnValues: [],
  partnerColumnList: [],
  partnerDefinitions: []
  partnerColumnNames: [],
  partnerDataTypes: [],
  partnerDe: [],
  partnerEn: [],

  partnersOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-Partner', whitelist:  [ ] },
  (state: IPartnerState = initialPartnerState, action: any) => {
    switch (action.type) {
      case actionTypes.GetPartnerTableData: {
        const partnerColumnValues = JSON.parse(action.payload.data.partners);
        let headers = JSON.parse(action.payload.data.headers);
        let partnerDefinitions = JSON.parse(action.payload.data.definitions);
        let partnerColumnNames = action.payload.data.columnNames;
        let partnerDataTypes = action.payload.data.dataTypes;
        let partnerColumnList: any = [];
        let partnersOptions = action.payload.data.options;
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          partnerColumnList.push(newElement[0]);
        });
        return { ...state, partnerColumnList, partnerColumnValues, partnerDefinitions, partnerDataTypes , partnerColumnNames, partnersOptions};
      }
    
      case actionTypes.SetPartnerData: {
        const partnerColumnValues = action.payload.data;
        return { ...state, partnerColumnValues };
      }

      case actionTypes.GetPartnerTranslateData: {
        const partnerDe = JSON.parse(action.payload.data.de);
        const partnerEn = JSON.parse(action.payload.data.en);
        return { ...state, partnerDe, partnerEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getPartnerTableData: (data: any) => ({ type: actionTypes.GetPartnerTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetPartnerTranslateData, payload: { data } }),
  setPartnerData: (data: any) => ({ type: actionTypes.SetPartnerData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
